import { useStaticQuery, graphql } from 'gatsby';

const useSiteMetadata = () => {
  const { site } = useStaticQuery(
  graphql`
    query {
    site {
      siteMetadata {
      title
      description
      siteURL
      }
    }
    }
  `,
  );
  return site;
};

export default useSiteMetadata;